import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { ComponentsModule } from '@components/components.module';
import { CoreModule } from '@core/core.module';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { AtomicModule } from 'src/app/shared/atomic/atomic.module';
import { MortgageSummaryTileComponent } from './components/mortgage-summary-tile/mortgage-summary-tile.component';
import { SelectMortgageInstructionsComponent } from './llc/components/select-mortgage-instructions/select-mortgage-instructions.component';
import { LlcDataComponent } from './llc/llc-data/llc-data.component';
import { LlcResourcesComponent } from './llc/llc-resources/llc-resources.component';
import { CloserSyncRFFComponent } from './closer-sync/closer-sync-rff/closer-sync-rff.component';
import { CloserSyncCreateMortgageComponent } from './closer-sync/closer-sync-create-mortgage/closer-sync-create-mortgage.component';
import { CloserSyncMortgageHeaderComponent } from './closer-sync/components/closer-sync-mortgage-header/closer-sync-mortgage-header.component';
import { CloserSyncFundingDetailsComponent } from './closer-sync/components/closer-sync-funding-details/closer-sync-funding-details.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MortgageDocumentsComponent } from './manual/components/mortgage-documents/mortgage-documents.component';
import { MatMenuModule } from '@angular/material/menu';
import { FundingMethodPipe } from '@core/pipes/funding-method.pipe';
import { FundingOptionComponent } from './closer-sync/components/closer-sync-mortgage-header/validation/funding-option/funding-option.component';
import { CloserSyncSyncMortgageFieldsComponent } from './closer-sync/closer-sync-create-mortgage/components/closer-sync-sync-mortgage-fields/closer-sync-sync-mortgage-fields.component';
import { CloserSyncReviewMortgageDetailsComponent } from './closer-sync/closer-sync-create-mortgage/components/closer-sync-mortgage-details/closer-sync-review-mortgage-details.component';
import { BorrowersComponent } from './llc/sync/existing-matter/borrowers/borrowers.component';
import { LLCBorrowerAssignComponent } from './llc/sync/components/borrower/borrower.component';
import { SyncHeaderComponent } from './llc/sync/components/sync-header/sync-header.component';
import { AddEditTrustAccountComponent } from '../../manage/trust-accounts/add-edit-trust-account/add-edit-trust-account.component';
import { AddEditLocalBranchComponent } from '../../manage/trust-accounts/add-edit-local-branch/add-edit-local-branch.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { ApsVTBFormComponent } from './vtb/aps-vtb-form/aps-vtb-form.component';
import { MortgagePrioritySelectorComponent } from './components/mortgage-priority-selector/mortgage-priority-selector.component';
import { IconsModule } from 'src/app/ui/icons/icons.module';
import { CloserSyncPackagesComponent } from './closer-sync/components/closer-sync-documents/closer-sync-packages/closer-sync-packages.component';
import { SendPackageToLenderComponent } from './closer-sync/components/closer-sync-documents/closer-sync-generate-package/components/send-package-to-lender/send-package-to-lender.component';
import { CloserSyncGeneratePackageComponent } from './closer-sync/components/closer-sync-documents/closer-sync-generate-package/closer-sync-generate-package.component';
import { CloserSyncMortgageFunderComponent } from './closer-sync/components/closer-sync-mortgage-funder/closer-sync-mortgage-funder.component';
import { MortgageUploadedDocumentsComponent } from './manual/components/uploaded-documents/uploaded-documents.component';
import { UiModule } from 'src/app/ui/ui.module';
import { CloserSyncMissingDocumentsComponent } from './closer-sync/components/closer-sync-documents/closer-sync-missing-documents/closer-sync-missing-documents.component';
import { MortgageTabsComponent } from './llc/components/mortgage-tabs/mortgage-tabs.component';
import { MortgageSelectorTabsComponent } from './components/mortgage-selector-tabs/mortgage-selector-tabs.component';
import { SendPackageToLenderDemoComponent } from './closer-sync/components/closer-sync-documents/closer-sync-generate-package/components/send-package-to-lender-demo/send-package-to-lender-demo.component';

const components = [
	LlcDataComponent,
	LlcResourcesComponent,
	MortgageSummaryTileComponent,
	SelectMortgageInstructionsComponent,
	CloserSyncRFFComponent,
	CloserSyncCreateMortgageComponent,
	CloserSyncMortgageHeaderComponent,
	CloserSyncFundingDetailsComponent,
	CloserSyncMortgageFunderComponent,
	MortgageDocumentsComponent,
	FundingOptionComponent,
	CloserSyncSyncMortgageFieldsComponent,
	CloserSyncReviewMortgageDetailsComponent,
	BorrowersComponent,
	LLCBorrowerAssignComponent,
	SyncHeaderComponent,
	AddEditTrustAccountComponent,
	AddEditLocalBranchComponent,
	ApsVTBFormComponent,
	MortgagePrioritySelectorComponent,
	CloserSyncGeneratePackageComponent,
	SendPackageToLenderComponent,
	SendPackageToLenderDemoComponent,
	CloserSyncPackagesComponent,
	MortgageUploadedDocumentsComponent,
	CloserSyncMissingDocumentsComponent,
	MortgageTabsComponent,
	MortgageSelectorTabsComponent,
];

@NgModule({
	declarations: components,
	imports: [
		UiModule,
		MatMenuModule,
		ReactiveFormsModule,
		CommonModule,
		AtomicModule,
		FormsModule,
		CoreModule,
		ComponentsModule,
		RouterModule,
		MatTooltipModule,
		MatTableModule,
		MatSortModule,
		MatDialogModule,
		NgxJsonViewerModule,
		FundingMethodPipe,
		MatSidenavModule,
		IconsModule,
	],
	providers: [DatePipe],
	exports: components,
})
export class MortgagesModule {}
